import {
  getAuthUser,
  getPermissions,
  checkForAccess,
  getSessionTime,
  checkForEnvMatch,
  getCookie
} from '@parkhub/parkhub-ui';

export {
  getAuthUser,
  getPermissions,
  checkForAccess,
  getSessionTime,
  getCookie
};

const COOKIE_EXP_MIN = 1440; /* 1 day */
export const SESSION_CHECK_INTERVAL_SEC = 10000; /* 10 seconds */

/**
 * @param {string} [urlParams]
 */
export function signOut(urlParams = '') {
  return window.location.replace(`${process.env.REACT_APP_SUITE_URL + 'sign-out' + urlParams}`);
}

/**
 * Check if user is authenticated
 * @return {boolean} - if cookie is valid, env matches, and user has permissions true : false
 */
export const checkAuth = () => {
  const authCookie = getCookie(process.env.REACT_APP_SUITE_USER_COOKIE_NAME);
  const hasAppAccess = checkForAccess('suite.scheduler');

  return !!authCookie && checkForEnvMatch() && hasAppAccess;
};

/**
 * @returns {Promise} request updated user and permissions cookies
 */
export function refreshSession() {
  return new Promise((resolve, reject) => {
    const cookie = getCookie(process.env.REACT_APP_SUITE_USER_COOKIE_NAME);

    if (!cookie) {
      reject(new Error('Cannot refresh session because current cookie expired'));

      return;
    }

    fetch(`${process.env.REACT_APP_CORE_USER_API_URL}/authenticate?refreshCookie=true`, {
      method: 'POST',
      credentials: 'include'
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Failed to refresh session');
      })
      .then(data => resolve(data))
      .catch(error => reject(error));
  });
}

export function redirectToSignIn() {
  return window.location.replace(`${process.env.REACT_APP_SUITE_URL}signin?redirectUrl=${window.location.href}`);
}

export const shouldRefreshSession = () => {
  const minutes = getSessionTime();

  if (!minutes) {return false;}

  /* Refresh if we're within 10 minutes of expiration */
  return minutes >= (COOKIE_EXP_MIN - 10) && minutes < COOKIE_EXP_MIN;
};
